'use client';

import * as Dialog from '@radix-ui/react-dialog';

/** Figma „Overlay“ of the dialogs (60256:13843, 60152:16169): bg/overlay #0F1012 at 30 %. */
export function DialogOverlay() {
  return (
    <Dialog.Overlay className="fixed inset-0 z-[200] bg-[#0F1012]/30 data-[state=open]:animate-in data-[state=open]:fade-in-0 motion-reduce:animate-none" />
  );
}
